const isDevMode = process.env.REACT_APP_DEPLOY_ENV !== 'prod';

export const customLog = (...args: any) => {
  if (isDevMode) {
    void args;
  }
};
